import {Helmet} from "react-helmet";
import {Box, Container, Grid, inputBaseClasses, styled, TextField, Typography} from "@mui/material";
import CustomInput from "../../../theme/components/CustomInput";
import {useState} from "react";
import {LoadingButton} from "../../../theme/components/LoadingButton";

export default function ContactUs() {

    const [inputsData, setInputsData] = useState({

    });

    return (
        <>
            <Helmet>
                <title>تماس با ما - میلفا</title>
                </Helmet>
            <Container sx={{ mt: 3, mb: 7 }}>
                <Box width={1} sx={{ p: {xs: 2, lg: 2.5}, background: theme => theme.palette.grey.main }}>
                    <Typography variant="h1" fontSize={{ xs: "1.15rem", lg: "1.2rem" }} fontWeight={600}>فرم تماس با ما</Typography>
                    <Grid mt={0} component="form" container spacing={2}>
                        <Grid item xs={12} lg={3}>
                            <StyledInput
                                fullWidth
                                placeholder="موضوع"/>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <StyledInput
                                fullWidth
                                placeholder="نام و نام خانوادگی"/>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <StyledInput
                                fullWidth
                                placeholder="شماره تماس"/>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <StyledInput
                                fullWidth
                                placeholder="ایمیل"/>
                        </Grid>
                        <Grid item xs={12}>
                            <StyledInput
                                fullWidth multiline minRows={8}
                                placeholder="توضیحات"/>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <LoadingButton
                                type="submit"
                                fullWidth sx={{ py: 1.5 }}
                                disableElevation>
                                ارسال
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </>
    )
}

const StyledInput = styled(CustomInput)(({theme}) => ({
    background: theme.palette.primary.light + "80",
    color: theme.palette.primary.dark,
    borderRadius: 4,
    boxShadow: "none",
    [`& .${inputBaseClasses.input}::placeholder`]: {color: "#424242"}
}))